import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { SelectEntitiesDialogComponent } from 'app/projects/entity/src/lib/models/select-entities-dialog.component';
import { fuseAnimations } from 'app/projects/fuse/src/lib/animations';
import { FetchUsers } from '../../actions/fetch-entities.action';
import { SearchUsers } from '../../actions/search-entities.action';
import { User } from '../../models/user';

@Component({
    selector: 'app-select-users-dialog',
    templateUrl: './select-users-dialog.component.html',
    styleUrls: ['./select-users-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
})
export class SelectUsersDialogComponent extends SelectEntitiesDialogComponent<User> implements OnInit, OnDestroy {
    constructor(store: Store, dialogRef: MatDialogRef<SelectUsersDialogComponent>) {
        super(store, dialogRef, SearchUsers, FetchUsers);
    }
}
